export default __webpack_public_path__ + "static/media/reddit.13221e3c.svg";